import React from 'react';
import { StyledCardWrapper } from './card.style';

type Props = {
    flexDirection?: string;
    children: React.ReactNode;
};

export const Card: React.FC<Props> = ({ flexDirection = 'column', children }) => {
    return <StyledCardWrapper data-testid={'card-component'} flexDirection={flexDirection}>{children}</StyledCardWrapper>;
};
